//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Start",
  data () {
    return {
      optionsDecades: ['1950er', '1960er', '1970er', '1980er', '1990er', '2000er', '2010er', '2020er'],/* '1940er',  */
    }
  },
  methods: {
      startGame: function({ reset }) {
          this.$emit("startGame")
          if ( reset ) reset()
          
      }
  }
}
